// Angular
import {
	Component,
	EventEmitter,
	Input,
	Output
} from '@angular/core';

@Component({
	selector: 'cv-public-record-detail',
	templateUrl: './public-record-detail.component.html'
})
export class PublicRecordDetailComponent {
	@Input() publicRecord: any;
	@Output() usAsSubjectEvent = new EventEmitter<any>();

	get address(): string {
		let txt = `${this.publicRecord.propertyRecord.streetName} #${this.publicRecord.propertyRecord.streetNumber}`;

		if (this.publicRecord.propertyRecord.streetName === '' || this.publicRecord.propertyRecord.streetName === null) {
			txt = this.publicRecord.propertyRecord.unparsedAddress;
		}

		return txt;
	}

	/**
	 * Emit us as subject event
	 */
	usAsSubject(): void {
		this.usAsSubjectEvent.emit(this.publicRecord.id)
	}
}
